import Handlebars from 'handlebars'
import { useTenant } from 'src/app/hooks/context/context.hook'

type scelTemplateData = {
  customer?: {
    name?: string
  }
  resource?: {
    code?: string
  }
  reservedResource?: {
    start?: string
    end?: string
  }
  reservation?: {
    reservationReference: {
      mainGuest?: {
        name?: string
      }
      voucher?: string
    }
  }
}

export const useScelNoteHook = () => {
  const { scelTemplate } = useTenant()

  Handlebars.registerHelper('eq', (a, b) => a === b)

  const compileScelNote = (data: scelTemplateData): string | undefined => {
    if (scelTemplate) return Handlebars.compile(scelTemplate)(data)
    else console.log('scel template not defined')
  }

  return { compileScelNote }
}
